// 1 component
var HOUR_NUM = 'HH'; // 13
var MINUTE_NUM = 'mm'; // 45
var DAY_NUM = 'DD'; // 01
var DAY_TEXT = 'Do'; // 1er
var MONTH_NUM = 'MM'; // 02
var MONTH_TEXT = 'MMMM'; // février
var MONTH_SHORT_TEXT = 'MMM'; // févr.
var WEEKDAY_TEXT = 'dddd'; // mercredi
var WEEKDAY_SHORT_TEXT = 'ddd'; // mer.
var YEAR_NUM = 'YYYY'; // 2023
var YEAR_SHORT_NUM = 'YY'; // 23
// 2 components
var TIME_NUM = "".concat(HOUR_NUM, ":").concat(MINUTE_NUM); // 13:45
var DAY_MONTH_NUM = "".concat(DAY_NUM, "/").concat(MONTH_NUM); // 01/02
var DAY_MONTH_TEXT = "".concat(DAY_TEXT, " ").concat(MONTH_TEXT); // 1er février
var DAY_MONTH_SHORT_TEXT = "".concat(DAY_TEXT, " ").concat(MONTH_SHORT_TEXT); // 1er févr.
var WEEKDAY_DAY_TEXT = "".concat(WEEKDAY_TEXT, " ").concat(DAY_TEXT); // mercredi 1er
var WEEKDAY_DAY_SHORT_TEXT = "".concat(WEEKDAY_SHORT_TEXT, " ").concat(DAY_TEXT); // mer. 1er
var MONTH_YEAR_TEXT = "".concat(MONTH_TEXT, " ").concat(YEAR_NUM); // février 2023
var MONTH_YEAR_SHORT_TEXT = "".concat(MONTH_SHORT_TEXT, " ").concat(YEAR_NUM); // févr. 2023
// 3 components
var WEEKDAY_DAY_MONTH_TEXT = "".concat(WEEKDAY_DAY_TEXT, " ").concat(MONTH_TEXT); // mercredi 1er février
var WEEKDAY_DAY_MONTH_SHORT_TEXT = "".concat(WEEKDAY_DAY_SHORT_TEXT, " ").concat(MONTH_SHORT_TEXT); // mer. 1er févr.
var DATE_NUM = "".concat(DAY_MONTH_NUM, "/").concat(YEAR_NUM); // 01/02/2023
var DATE_TEXT = "".concat(DAY_MONTH_TEXT, " ").concat(YEAR_NUM); // 1er février 2023
var DATE_SHORT_TEXT = "".concat(DAY_MONTH_SHORT_TEXT, " ").concat(YEAR_NUM); // 1er févr. 2023
// 4 components
var WEEKDAY_DATE_TEXT = "".concat(WEEKDAY_TEXT, " ").concat(DATE_TEXT); // mercredi 1er février 2023
var WEEKDAY_DATE_SHORT_TEXT = "".concat(WEEKDAY_SHORT_TEXT, " ").concat(DATE_SHORT_TEXT); // mer. 1er févr. 2023
// 5 components
var DATE_TIME_NUM = "".concat(DATE_NUM, " ").concat(TIME_NUM); // 01/02/2023 13:45
var DATE_TIME_TEXT = "".concat(DATE_TEXT, " ").concat(TIME_NUM); // 1er février 2023 13:45
var DATE_TIME_SHORT_TEXT = "".concat(DATE_SHORT_TEXT, " ").concat(TIME_NUM); // 1er févr. 2023 13:45
// 6 components
var WEEKDAY_DATE_TIME_TEXT = "".concat(WEEKDAY_TEXT, " ").concat(DATE_TIME_TEXT); // mercredi 1er février 2023 13:45
var WEEKDAY_DATE_TIME_SHORT_TEXT = "".concat(WEEKDAY_SHORT_TEXT, " ").concat(DATE_TIME_SHORT_TEXT); // mer. 1er févr. 2023 13:45
var formatList = {
    // 1 component
    HOUR_NUM: HOUR_NUM,
    MINUTE_NUM: MINUTE_NUM,
    DAY_NUM: DAY_NUM,
    DAY_TEXT: DAY_TEXT,
    MONTH_NUM: MONTH_NUM,
    MONTH_TEXT: MONTH_TEXT,
    MONTH_SHORT_TEXT: MONTH_SHORT_TEXT,
    WEEKDAY_TEXT: WEEKDAY_TEXT,
    WEEKDAY_SHORT_TEXT: WEEKDAY_SHORT_TEXT,
    YEAR_NUM: YEAR_NUM,
    YEAR_SHORT_NUM: YEAR_SHORT_NUM,
    // 2 components
    TIME_NUM: TIME_NUM,
    DAY_MONTH_NUM: DAY_MONTH_NUM,
    DAY_MONTH_TEXT: DAY_MONTH_TEXT,
    DAY_MONTH_SHORT_TEXT: DAY_MONTH_SHORT_TEXT,
    WEEKDAY_DAY_TEXT: WEEKDAY_DAY_TEXT,
    WEEKDAY_DAY_SHORT_TEXT: WEEKDAY_DAY_SHORT_TEXT,
    MONTH_YEAR_TEXT: MONTH_YEAR_TEXT,
    MONTH_YEAR_SHORT_TEXT: MONTH_YEAR_SHORT_TEXT,
    // 3 components
    WEEKDAY_DAY_MONTH_TEXT: WEEKDAY_DAY_MONTH_TEXT,
    WEEKDAY_DAY_MONTH_SHORT_TEXT: WEEKDAY_DAY_MONTH_SHORT_TEXT,
    DATE_NUM: DATE_NUM,
    DATE_TEXT: DATE_TEXT,
    DATE_SHORT_TEXT: DATE_SHORT_TEXT,
    // 4 components
    WEEKDAY_DATE_TEXT: WEEKDAY_DATE_TEXT,
    WEEKDAY_DATE_SHORT_TEXT: WEEKDAY_DATE_SHORT_TEXT,
    // 5 components
    DATE_TIME_NUM: DATE_TIME_NUM,
    DATE_TIME_TEXT: DATE_TIME_TEXT,
    DATE_TIME_SHORT_TEXT: DATE_TIME_SHORT_TEXT,
    // 6 components
    WEEKDAY_DATE_TIME_TEXT: WEEKDAY_DATE_TIME_TEXT,
    WEEKDAY_DATE_TIME_SHORT_TEXT: WEEKDAY_DATE_TIME_SHORT_TEXT,
};
export default formatList;
